import React, { Component } from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { XTabNav } from '@/components/xqxc_ui';
import RewardRule from '../rewardRule';//奖惩规则
import SendRule from '../sendRule';//派单规则
import Timeout from '../timeout';//超时规则
import EvaluationRule from '../evaluationrule'; //评价规则
import Canceltime from '../canceltime'; //取消规则
import TopupRules from '../topuprules'; //充值规则
import { removeSessionStorage, getSessionStorage } from '@/assets/js/storage';

class Main extends Component {

    state = {
        tab: [
            // { id: 1, label: '奖惩规则' },
            { id: 3, label: '评价规则' },
            { id: 4, label: '派单规则' },
            { id: 5, label: '超时规则' },
            { id: 2, label: '取消规则' },
            { id: 6, label: '充值规则' },
        ],
        curTabID: 3,  // 默认显示的tab
    }

    componentDidMount() {
        //如果路由过来的state参数带tabID值，则渲染该tabID值下的内容
        let sessionpath = 'system/operatingrule/createInfo';
        if (getSessionStorage(sessionpath)) {
            this.setState({
                curTabID: JSON.parse(getSessionStorage(sessionpath))
            }, () => {
                removeSessionStorage(sessionpath);
            });
        }
    }

    // Tab导航切换操作回调
    _tabChangeHandle = (tabID) => {
        this.setState({ curTabID: tabID });
    }

    // 渲染相应Tab导航下的内容 
    _renderPage = () => {
        const { curTabID } = this.state;
        switch (curTabID) {
            case 1:
                return <RewardRule curTabID={this.state.curTabID} history={this.props.history} updateContent={this.props.updateContent} />;
            case 3:
                return <EvaluationRule curTabID={this.state.curTabID} history={this.props.history} updateContent={this.props.updateContent} />;
            case 4:
                return <SendRule curTabID={this.state.curTabID} history={this.props.history} updateContent={this.props.updateContent} />;
            case 5:
                return <Timeout curTabID={this.state.curTabID} history={this.props.history} updateContent={this.props.updateContent} />;
            case 2:
                return <Canceltime curTabID={this.state.curTabID} history={this.props.history} updateContent={this.props.updateContent} />;
            case 6:
                return <TopupRules curTabID={this.state.curTabID} />;
            default:
                return null;

        }
    }

    render() {
        return (
            <div className={styles.flexBoxContainer}>
                <XTabNav renderData={this.state.tab} onChange={this._tabChangeHandle} activedID={this.state.curTabID} />
                <div className={styles.tableContainer} style={{ paddingTop: 0 }}>
                    {this._renderPage()}
                </div>
            </div>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object, // 路由history对象
    updateContent: PropTypes.func, // 跳转其它路由页面
};

export default Main;